import styled from "@emotion/styled";

export const HostContainer = styled.div`
  padding: 30px 8px;
  text-align: center;
`;
